import {Lightbox} from '../../classes/Lightbox';

const initShowreel = () => {
	const offset = ( el ) => {
		const rect = el.getBoundingClientRect();
		const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		return {
			top: rect.top + scrollTop,
			left: rect.left + scrollLeft,
		};
	};

	const playBtnMove = ( component ) => {
		const playBtn = component.querySelector( 'div.circle' );
		const pictureWrapper = component.querySelector( 'picture' );

		let windowWidth = window.innerWidth;

		let mouseX = 0;
		let mouseY = 0;
		let xp = 0;
		let yp = 0;

		pictureWrapper.addEventListener( 'mousemove', ( e ) => {
			const headerWidth = document.querySelector( 'header' ).offsetWidth;
			const componentPaddings = getComputedStyle( component );
			const paddingLeft = Number( componentPaddings.paddingLeft.slice( 0, -2 ) );
			const topOffest = offset( component ).top;
			
			playBtn.style.display = 'flex';
			windowWidth = window.innerWidth;

			if ( windowWidth < 1024 )
			{
				playBtn.style.display = 'none';
			}

			mouseX = e.clientX - ( 48 + headerWidth + paddingLeft );
			mouseY = e.pageY - ( 48 + topOffest );
		} );

		// pictureWrapper.addEventListener( 'mouseleave', ( e ) => {
		// 	playBtn.style.transform = 'translate(638px, 104px)';
		// } );

		setInterval( () => {
			if ( windowWidth < 1024 ) return;

			xp += ( ( mouseX - xp ) / 6 );
			yp += ( ( mouseY - yp ) / 6 );

			playBtn.style.transform = `translate(${xp}px, ${yp}px)`;
		}, 20 );
	};

	const showreels = document.querySelectorAll( 'section.showreel' );

	if ( !showreels.length ) return;

	showreels.forEach( ( component ) => {
		const videoPlayer = component.querySelector( '.video-player' );
		const pictureWrapper = component.querySelector( 'picture' );

		pictureWrapper.addEventListener( 'click', () => {
			component.classList.add( 'show' );

			setTimeout( () => {
				Lightbox.open( videoPlayer, null, 'video-player' );

				const lightBox = Lightbox.getLightbox();
			
				if ( !lightBox )
				{
					return;
				}

				const video = lightBox.querySelector( '.video-player > video' );

				lightBox.addEventListener( 'click', ( {target} ) => {
					if ( target.closest( 'button.close' ) )
					{
						setTimeout( () => {
							component.classList.remove( 'show' );
						}, 100 );
					}

					if ( target.closest( 'video.pause' ) )
					{
						video.play();
						video.classList.remove( 'pause' );
						video.classList.add( 'play' );
					}
					else if ( target.closest( 'video.play' ) )
					{
						video.pause();
						video.classList.add( 'pause' );
						video.classList.remove( 'play' );
					}
				} );

				video.play();
				video.classList.add( 'play' );
			}, 100 );
		} );

		playBtnMove( component );
	} );
};

export {
	initShowreel,
};
